<template>
  <div class="row">
    <div class="col-xl-12">
      <container-headline
        class="col-xl-12"
        :headline="$t('global.emails')"
        :col="3"
      >
        <div class="row mt-2 d-flex justify-content-between">
          <div class="ml-4">
            <button class="btn btn-success" @click="neueMail" v-if="editable">
              <font-awesome-icon
                icon="fa-duotone fa-envelope-open-text"
                class="mr-2"
              />
              <span>{{ $t("global.new") }}</span>
            </button>
          </div>
          <div class="mr-4">
            <button
              class="btn btn-primary mr-2"
              @click="toggleHasMaxHeight"
              v-if="showListToggleButton"
            >
              <font-awesome-icon
                class="mr-2"
                icon="fa-regular fa-plus"
                v-if="hasMaxHeight === true"
              />
              <font-awesome-icon
                class="mr-2"
                icon="fa-regular fa-minus"
                v-if="hasMaxHeight === false"
              />{{ hasMaxHeight ? "Liste aufklappen" : "Liste zuklappen" }}
            </button>
            <button
              class="btn btn-danger"
              @click="oeffneLoeschenModal"
              v-if="editable"
              :disabled="notYetSent || selectedIds.length === 0"
              :title="selectedIds.length === 0 ? $t('global.selectminone') : ''"
            >
              <font-awesome-icon class="mr-2" icon="fa-duotone fa-trash" />
              <span>{{ $t("global.delete") }}</span>
            </button>
          </div>
        </div>
      </container-headline>
      <div class="row col-xl-12">
        <div class="col-xl-12 block belegliste br-t-l-0">
          <div ref="tableParent">
            <b-table
              ref="selectableTable"
              tbody-tr-class="item"
              :items="mailliste"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-compare="sortDatum"
              :busy="isBusy"
              show-empty
              sort-icon-left
              :style="hasMaxHeight ? 'max-height: 300px' : ''"
              fixed
              responsive
              sticky-header
              selectable
              select-mode="range"
              @row-dblclicked="details"
              small
              thead-tr-class="pointer"
            >
              <template v-slot:head(selected)="row">
                <b-form-checkbox
                  v-model="row.selected"
                  @input="selectAllRows(row)"
                ></b-form-checkbox>
              </template>

              <template v-slot:cell(selected)="row">
                <b-form-checkbox
                  v-model="row.item.selected"
                  @input="onRowSelected(row)"
                ></b-form-checkbox>
              </template>

              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

              <template #empty>
                <div v-if="ladeFehler" class="text-center text-danger my-2">
                  <strong>{{ $t("global.errorwhileloading") }}</strong>
                </div>
                <div v-if="!ladeFehler" class="text-center text-primary my-2">
                  <strong>{{ $t("global.nodataavailable") }}</strong>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>

    <loeschen-modal
      id="mail-loeschen-modal"
      @confirmed="mailLoeschen"
      :selectedIds="Array.from(new Set(selectedIds))"
    />
  </div>
</template>

<script>
import AppApi from "@/api/AppApi";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import { BSpinner } from "bootstrap-vue";
import ContainerHeadline from "@/components/ContainerHeadline";

import LoeschenModal from "@/components/Modals/LoeschenModal";

import reiter from "@/mixins/Reiter";
export default {
  components: {
    ContainerHeadline,
    LoeschenModal,
    BSpinner,
  },
  mixins: [reiter],
  props: {
    person: {
      type: String,
      required: false,
    },
    firma: {
      type: String,
      required: false,
    },
    anmeldung: {
      type: String,
      required: false,
    },
    shown: {
      type: Boolean,
      required: false,
    },
    editable: {
      type: Boolean,
      required: true,
    },
    mailadressen: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      page: 0,
      notYetSent: false,
      infiniteId: +new Date(),
      anzahlProPage: 100,
      sortBy: "",
      sortDesc: false,
      isBusy: false,
      ladeFehler: false,
      mailliste: [],
      selected: [],
      selectedIds: [],
      selectedObjects: [],
      hasMaxHeight: true,
      showListToggleButton: null,
    };
  },
  computed: {
    fields() {
      return [
        { key: "selected", label: "" },
        {
          key: "zeitpunkt",
          sortable: true,
          label: this.$t("global.createdon"),
        },
        { key: "betreff", sortable: true, label: this.$t("global.subject") },
        {
          key: "absender.personName",
          sortable: true,
          label: this.$t("global.sender"),
        },
        {
          key: "empfaengermail",
          sortable: true,
          label: this.$t("global.receiver"),
          formatter: (value, key, item) => {
            return item.isMassMail ? "Massenmail" : value;
          },
        },
        { key: "gesendet", sortable: true, label: this.$t("global.senton") },
        {
          key: "status",
          sortable: true,
          label: this.$t("global.processingstatus"),
          formatter: (value, key, item) => {
            return item.gesendet ? "Versendet" : "Entwurf";
          },
        },
      ];
    },
    queryParams: function () {
      var params = {
        page: this.page,
        count: this.anzahlProPage,
      };

      if (this.suche) params.suche = this.suche;

      return params;
    },
  },
  watch: {
    shown(val) {
      if (val && this.mailliste.length == 0) this.getMails();
    },
  },
  mounted() {
    if (this.shown && this.mailliste.length == 0) this.getMails();
  },
  created() {},
  methods: {
    getMails() {
      if (this.mailliste.length == 0) {
        this.isBusy = true;

        const apiCall = AppApi.get("mail-reiter/", {
          params: this.person ? { person: this.person } : { firma: this.firma },
        });

        apiCall
          .then((response) => {
            this.mailliste = response.data;
            this.ladeFehler = false;
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
            this.ladeFehler = true;
          })
          .finally(() => {
            this.isBusy = false;
            this.$nextTick(() => {
              this.showListToggleButton = !(
                this.$refs.tableParent.clientHeight < 300
              );
            });
          });
      }
    },

    details(mailliste) {
      this.$router.push({
        name: "mail",
        params: { id: mailliste.id, anzeige: 0 },
      });
    },
    /*
    neueMail() {
      this.$router.push({
        name: "mail",
        params: { id: null, anzeige: 0 },
      });
    },
*/

    neueMail() {
      if (this.mailadressen && this.mailadressen.length > 0) {
        const query = {}
        if (this.anmeldung) query.anmeldung = this.anmeldung
        if (this.person) query.person = this.person
        if (this.firma) query.firma = this.firma
        if (this.mailadressen[0]) query.mail = this.mailadressen[0].bezeichnung

        this.$router.push({
          name: 'mail-neu',
          query,
        })
      } else {
        this.$notify({
          type: "warning",
          title: this.$t("global.hint"),
          text: this.$t("global.nomailaddressdeposited"),
        });
      }
    },

    toggleHasMaxHeight() {
      this.hasMaxHeight = !this.hasMaxHeight;
    },

    selectAllRows(row) {
      if (row.selected) {
        this.$refs.selectableTable.items.forEach((gp) => {
          gp.selected = true;
        });
      } else {
        this.$refs.selectableTable.items.forEach((gp) => {
          gp.selected = false;
        });
        this.selectedIds = [];
      }
      this.checkAllowSend();
      this.$forceUpdate();
    },

    onRowSelected(row) {
      if (row.item.selected) {
        this.selectedIds.push(row.item.id);
        this.selectedObjects.push(row.item);
      } else {
        this.selectedIds = this.selectedIds.filter((id) => id != row.item.id);
        this.selectedObjects = this.selectedObjects.filter(
          (item) => item.id != row.item.id
        );
      }
      this.checkAllowSend();
    },
    checkAllowSend() {
      if (this.selectedObjects.some((obj) => obj.gesendet !== null)) {
        this.notYetSent = true;
      } else {
        this.notYetSent = false;
      }
    },

    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0)
        this.$bus.$emit("openLoeschenModal", "mail-loeschen-modal");
    },

    mailLoeschen() {
      const mailDeleteParams = this.person ? { ids: this.selectedIds.join(","), person: this.person } : { ids: this.selectedIds.join(","), firma: this.firma };
      AppApi.delete("mail-reiter/", {
        params: mailDeleteParams,
      }).then(() => {
        this.$emit("confirmed");
        this.selectedIds = [];
        this.mailliste = [];
        this.getMails();
      });
    },
    sortDatum(datumA, datumB, key) {
      if ((!key.includes("gesendet"), !key.includes("zeitpunkt"))) {
        return false;
      } else {
        let a = null;
        let b = null;

        if (key.includes(".")) {
          a = this.resolveTermin(key, datumA);
          b = this.resolveTermin(key, datumB);
        } else {
          a = datumA[key];
          b = datumB[key];
        }
        if (a && b) {
          a = a.split(".");
          b = b.split(".");
          a =
            parseInt(a[2], 10) * 10000 +
            parseInt(a[1], 10) * 100 +
            parseInt(a[0]);
          b =
            parseInt(b[2], 10) * 10000 +
            parseInt(b[1], 10) * 100 +
            parseInt(b[0]);
          return a - b;
        } else {
          return false;
        }
      }
    },
  },
};
</script>
